import { gql } from '@edreamsodigeo/frontend-api-client';

export const api = gql`
  fragment CarrierInfo on Carrier {
    id
    name
  }
`;
